module.exports = __webpack_public_path__ + "img/translations.f5228941.svg";